import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Twemoji from "react-twemoji";

import Loading from "./Loading";
import ImageComponent from "../components/ImageComponent";
import VideoComponent from "../components/VideoComponent";
import BulletListComponent from "../components/BulletListComponent";
import SourceCodeComponent from "../components/SourceCodeComponent";
import Comment from "../components/Comment";
import Console from "../components/Console";
import PageHeader from "../components/PageHeader";
import HeadingToc from "../components/HeadingToc";

export default function Library(){
    const id = useLocation().pathname;
    const contentRef = useRef(null);

    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [data,setData] = useState([]);
    const [lastEdited, setLastEdited] = useState("");

    const consoleMsg = `
    Client requested for library page
    Server responded with library page
    `

    const fetchData = async () => {
        try {
            const response = await fetch(`https://imajin.dev/api/retrieve-block-children-library`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const responseData = await response.json();
            setData(responseData.results);

            const isoDate = responseData.results[0].last_edited_time; //ISO 8601 Timestamp
            const formattedDate = new Date(isoDate).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
            });

            setLastEdited(formattedDate);

            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    useEffect( () => {
        fetchData();
    }, []);

    return (
        <div style = { { backgroundColor : "var(--bg)" } }>
            { loading ? <Loading/> :
            <Twemoji options = { { className: 'twemoji' } } key = { location.pathname }>
                <div className = "page">
                    {/* <Console text = { consoleMsg }/> */}

                    <PageHeader title = "Library" date = { lastEdited }/>
                    <HeadingToc containerRef = { contentRef } maxLevel={2} />

                    <div ref = { contentRef }>
                        { data.map( ( item, index ) => (
                            <div key = { item.id }>
                                <div style = { { display : "flex", flexDirection : "row", gap : "40px", alignItems : "center" } }>
                                
                                    <p className = "meta2" style = { { width : "4px", color : "var(--black16)" } }>{ index % 8 === 0 ? index : "-" }</p>

                                    { item.type === "paragraph" && (
                                        <div>
                                            { item[item.type]?.rich_text?.length === 0 ? ( 
                                                <div className = "br" /> 
                                            ) : item[item.type]?.rich_text?.[0]?.href ? (
                                                <a className = "animated-underline" target="_blank" href={item[item.type]?.rich_text?.[0]?.href}>
                                                    {item[item.type]?.rich_text?.[0]?.href}
                                                </a>
                                            ) : (
                                            <p
                                                style = {{
                                                color:
                                                    item[item.type]?.color === "black"
                                                    ? "black"
                                                    : item[item.type]?.color === "blue"
                                                    ? "blue"
                                                    : "inherit", // Default color
                                                }}
                                            >
                                                { item[item.type]?.rich_text?.[0]?.plain_text }
                                            </p>
                                            )}
                                        </div>
                                    )}

                                    { item.type === "heading_1" && (
                                        <h1 className = "heading">{item[item.type]?.rich_text[0]?.plain_text}</h1> 
                                    )}

                                    { item.type === "heading_2" && (
                                        <h2 className = "heading">{item[item.type]?.rich_text[0]?.plain_text}</h2> 
                                    )}

                                    { item.type === "heading_3" && (
                                        <h3 className = "heading">{item[item.type]?.rich_text[0]?.plain_text}</h3> 
                                    )}

                                    {item.type === "bulleted_list_item" && (
                                        <BulletListComponent item={item} />
                                    )}

                                    {item.type === "image" && (
                                        <ImageComponent data={item[item.type]} />
                                    )}

                                    {item.type === "video" && (
                                        <VideoComponent data={item[item.type]} />
                                    )}

                                    {item.type === "divider" && <div className = "hr"/>}

                                    { item.type === "code" && (
                                        <SourceCodeComponent data = {item[item.type]}/>
                                    )}

                                </div>
                            </div>
                        ))}
                    </div>

                </div>

                <Comment id = { id } blog = { id }/>

                </Twemoji>
            }
        </div>
    );
}